const gallery = {
	slideIndex: 1,
	modal: null,
	dotsSlider: null,
	itemsPerView: 4,
	transitionDuration: 400,
	
	init(modalSelector = '#LightboxModal1') {
		this.modal = document.querySelector(modalSelector);
		
		// Nur ausführen wenn Modal existiert
		if (!this.modal) {
			return;
		}
		
		this.dotsSlider = this.modal.querySelector('.dots-slider');
		this.attachEventListeners();
		this.showSlides(this.slideIndex);
	},
	
	attachEventListeners() {
		// Galerie-Bilder zum Öffnen des Modals
		document.querySelectorAll('.gallery-images img').forEach((img, index) => {
			img.addEventListener('click', () => this.openModal(index + 1));
		});
		
		// Close-Button
		document.querySelector('[data-action="close-modal"]')?.addEventListener('click', () => this.closeModal());
		
		// Prev/Next-Buttons
		document.querySelector('[data-action="prev-slide"]')?.addEventListener('click', () => this.plusSlides(-1));
		document.querySelector('[data-action="next-slide"]')?.addEventListener('click', () => this.plusSlides(1));
		
		// Dots (Thumbnails)
		document.querySelectorAll('.lightbox-dots').forEach(dot => {
			dot.addEventListener('click', () => {
				const slideNum = parseInt(dot.getAttribute('data-slide'));
				this.currentSlide(slideNum);
			});
		});
		
		// Modal schliessen bei Klick ausserhalb
		this.modal?.addEventListener('click', (e) => {
			if (e.target === this.modal) {
				this.closeModal();
			}
		});
	},
	
	openModal(slideNum = 1) {
		this.modal.style.display = 'block';
		this.currentSlide(slideNum);
	},
	
	closeModal() {
		this.modal.style.display = 'none';
	},
	
	plusSlides(n) {
		this.showSlides(this.slideIndex += n);
	},
	
	currentSlide(n) {
		this.showSlides(this.slideIndex = n);
	},
	
	scrollDotsToActive() {
		const dots = this.dotsSlider.querySelectorAll('.lightbox-dots');
		const activeDot = dots[this.slideIndex - 1];
		
		if (!activeDot) return;
		
		const dotWidth = activeDot.offsetWidth;
		const dotOffset = activeDot.offsetLeft;
		const containerWidth = this.dotsSlider.parentElement.offsetWidth;
		const scrollLeft = this.dotsSlider.parentElement.scrollLeft;
		
		// Berechne die ideale Position zum Scrollen
		const targetScroll = dotOffset - (containerWidth / 2) + (dotWidth / 2);
		
		this.dotsSlider.parentElement.scrollTo({
			left: Math.max(0, targetScroll),
			behavior: 'smooth'
		});
	},
	
	showSlides(n) {
		const slides = this.modal.querySelectorAll('.lightbox-slides');
		const dots = this.modal.querySelectorAll('.lightbox-dots');
		const captionText = this.modal.querySelector('#caption');
		
		if (n > slides.length) { this.slideIndex = 1; }
		if (n < 1) { this.slideIndex = slides.length; }
		
		// Fade-Out alle Slides
		slides.forEach(slide => {
			slide.classList.remove('active');
		});
		dots.forEach(dot => dot.classList.remove('active'));
		
		// Nach der Fade-Out Animation, Fade-In neue Slide
		setTimeout(() => {
			slides[this.slideIndex - 1].classList.add('active');
			dots[this.slideIndex - 1].classList.add('active');
			captionText.innerHTML = slides[this.slideIndex - 1].querySelector('img').alt;
			
			// Scroll zu aktuellem Dot
			this.scrollDotsToActive();
		}, this.transitionDuration / 2);
	}
};

// Initialisierung
document.addEventListener('DOMContentLoaded', () => {
	gallery.init();
});
